'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchInvite = exports.logout = exports.register = exports.login = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _http = require('../utils/services/http');

var _http2 = _interopRequireDefault(_http);

var _authService = require('./authService');

var _formSubmissionExceptionHandler = require('../components/form/formSubmissionExceptionHandler');

var _formSubmissionExceptionHandler2 = _interopRequireDefault(_formSubmissionExceptionHandler);

var _navigationActions = require('../reducers/navigationActions');

var _authConstants = require('./authConstants');

var AUTH_ACTION_TYPES = _interopRequireWildcard(_authConstants);

var _registerFormConstants = require('./modals/register/registerFormConstants');

var _loginFormConstants = require('./modals/login/loginFormConstants');

var _httpConstants = require('../../common/utils/http/httpConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Lib


// Utils


// Actions


// Constants


var LOGIN_REGISTER_TIMEOUT = 15000;

var login = exports.login = function login(email, password) {
    return function (dispatch, getState) {
        dispatch({ type: AUTH_ACTION_TYPES.LOGIN_SUBMIT });

        var loginConfig = {
            method: _httpConstants.METHODS.POST,
            url: 'auth/login',
            timeout: LOGIN_REGISTER_TIMEOUT,
            data: {
                email: email.toLowerCase(),
                password: password
            }
        };

        return (0, _http2.default)(loginConfig).then(function (response) {
            dispatch({ type: AUTH_ACTION_TYPES.LOGIN_SUCCESS });

            var token = response.data.token;

            if (!token) throw new Error('No token found');

            (0, _authService.setCurrentUserToken)(response.data.token);
            dispatch((0, _navigationActions.navigateToRootWorkspace)());
        }).catch((0, _formSubmissionExceptionHandler2.default)({ dispatch: dispatch, getState: getState, form: _loginFormConstants.LOGIN_FORM_NAME, sensitive: true }));
    };
};

var register = function register(_ref) {
    var email = _ref.email,
        rest = _objectWithoutProperties(_ref, ['email']);

    return function (dispatch, getState) {
        dispatch({ type: AUTH_ACTION_TYPES.REGISTER_SUBMIT });

        var registerConfig = {
            method: _httpConstants.METHODS.POST,
            url: 'auth/register',
            timeout: LOGIN_REGISTER_TIMEOUT,
            data: _extends({
                email: email.toLowerCase()
            }, rest)
        };

        return (0, _http2.default)(registerConfig).then(function (response) {
            dispatch({ type: AUTH_ACTION_TYPES.REGISTER_SUCCESS });

            var token = response.data.token;

            if (!token) throw new Error('No token found');

            (0, _authService.setCurrentUserToken)(response.data.token);

            dispatch((0, _navigationActions.navigateToRootWorkspace)());
        }).catch((0, _formSubmissionExceptionHandler2.default)({ dispatch: dispatch, getState: getState, form: _registerFormConstants.REGISTER_FORM_NAME, sensitive: true }));
    };
};

exports.register = register;
var logout = exports.logout = function logout() {
    return function (dispatch, getState) {
        var state = getState();
        var userId = state.getIn(['app', 'currentUser', '_id']);

        (0, _authService.removeCurrentUserToken)();
        dispatch({ type: AUTH_ACTION_TYPES.LOGOUT, userId: userId, sync: false });
        dispatch((0, _navigationActions.navigateToLogin)());
    };
};

var fetchInvite = exports.fetchInvite = function fetchInvite() {
    return function (dispatch, getState) {
        var inviteCode = getState().get('routing').locationBeforeTransitions.query.invite;
        if (!inviteCode) return;

        var inviteConfig = {
            method: _httpConstants.METHODS.GET,
            url: 'invite/' + inviteCode
        };

        return (0, _http2.default)(inviteConfig).then(function (response) {
            dispatch(_extends({
                type: AUTH_ACTION_TYPES.REGISTER_INVITE_FETCHED
            }, response.data));
        }).catch(function (err) {
            return null;
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/authActions.js
// module id = 421
// module chunks = 0